import {filter, map, pairwise, startWith} from 'rxjs/operators';
import {interval} from 'rxjs';


export const EveryMinuteInMsTimer$ = interval(1000)
  .pipe(
    map(() => new Date().setSeconds(0, 0)),
    pairwise(),
    filter((pair) => pair[0] !== pair[1]),
    map(pair => pair[1]),
    startWith(new Date().setSeconds(0, 0)),
  );
